import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Retired standalone page — production kits now live inline in the Recurring
 * jobs page (moment 6, "What a visit costs us"), next to the costing settings
 * they feed.
 */
export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts/production-kits')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/contracts' });
  },
  component: () => null,
});
